<div xpoDialog class="switch-ram-roles-dialog">
  <h1 mat-dialog-title>
    Change RAM Roles
    <xpo-dialog-close-button></xpo-dialog-close-button>
  </h1>

  <div mat-dialog-content>
    <form [formGroup]="securityRolesForm" class="ram-roles-form">
      <h3>RAM Roles</h3>
      <mat-checkbox color="primary" [checked]="isAllSelected()" (change)="toggleSelectAll($event.checked)">
        Select All
      </mat-checkbox>
      <div formArrayName="selectedRamRoles">
        <div *ngFor="let role of ramRolesOptions; let i = index">
          <mat-checkbox color="primary" [formControlName]="i">{{ role }}</mat-checkbox>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-flat-button xpoSmallButton (click)="ramRolesSelection()">Switch</button>
  </div>
</div>
